import React, {ReactNode} from 'react';
import { ScheduleButton, ButtonContainer } from './ButtonStyle';
import {CSVLink} from 'react-csv';

interface ButtonScheduleProps {
  onClick: (e:any) => void;
  label: string;
  icon: ReactNode;
  htmlFor:string;
  type: string;
  data?: any;
  headers?:any;
  disable: boolean;
  filename?:string;
}


const ButtonSchedule: React.FC<ButtonScheduleProps> = ({onClick, label, icon, htmlFor, type, data, headers, disable, filename}) => {

  return (
    <>
      {type === 'download' ? (
         <ButtonContainer aria-disabled={disable} >
           {disable ? (
             <ScheduleButton disable={disable} htmlFor={htmlFor}>
             {icon}
             <span>{label}</span>
           </ScheduleButton>
           ) : (
            <CSVLink
            className="btn-download"
            data={data}
            headers={headers}
            filename={filename}
            >
            {icon}
            <span>{label}</span>
          </CSVLink>
           )}

        </ButtonContainer>

      ) : (
        <>
          <ScheduleButton 
            disable={disable} htmlFor={htmlFor}>
            {icon}
            <span>{label}</span>
          </ScheduleButton>
          <input
            style={{display:'none'}}
            name={htmlFor}
            id={htmlFor}
            type="file"
            accept={type === 'upload' ? ".csv" : '.xls,.xlsx'}
            onChange={onClick}
            disabled={disable}
          />
        </>
      )}
    </>
  )

}

export default ButtonSchedule;
